import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useFetch } from "../api";
import { Alerts, EmptyRow, Loading, Modal, Page, Pager } from "../components/ui";
import { PAGE_SIZE, qs, setQuery, text, when } from "../format";

export default function Contacts() {
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, Number(params.get("page")) || 1);
  const list = useFetch("/contacts" + qs({ page, limit: PAGE_SIZE }));
  const rows = Array.isArray(list.data?.data) ? list.data.data : [];
  const [open, setOpen] = useState(null);

  return (
    <Page title="Messages" text="Read only. These are messages from the website contact form.">
      <Alerts error={list.error} />
      {list.loading ? <Loading /> : (
        <div className="table-wrap">
          <table className="wide">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Phone</th><th>Subject</th><th>Message</th><th>Received</th></tr>
            </thead>
            <tbody>
              {rows.length ? rows.map((row) => (
                <tr key={row.id} className="click" onClick={() => setOpen(row)}>
                  <td>{row.name}</td>
                  <td><a href={"mailto:" + row.email} onClick={(event) => event.stopPropagation()}>{row.email}</a></td>
                  <td>{text(row.phone)}</td>
                  <td>{row.subject}</td>
                  <td className="clamp">{row.message}</td>
                  <td>{when(row.createdAt)}</td>
                </tr>
              )) : <EmptyRow cols={6} text="No messages" />}
            </tbody>
          </table>
        </div>
      )}
      {list.data ? (
        <Pager page={page} limit={PAGE_SIZE} total={list.data.total} onPage={(next) => setQuery(params, setParams, { page: next <= 1 ? "" : next })} />
      ) : null}
      {open ? (
        <Modal title={open.subject} onClose={() => setOpen(null)}>
          <p><strong>{open.name}</strong> · <a href={"mailto:" + open.email}>{open.email}</a></p>
          <p className="hint">{text(open.phone)} · {when(open.createdAt)}</p>
          <p className="clamp">{open.message}</p>
        </Modal>
      ) : null}
    </Page>
  );
}
